/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { Typography } from 'antd';
const { Text } = Typography;


export function HeaderText(props) {
    return (
        <>
            <Typography
                style={{
                    fontSize: '30px',
                    // fontFamily: 'Roboto',
                    // fontWeight : 'bold',
                    color: props.color ? props.color : '#828282'
                }}>
                {props.text}
            </Typography>
        </>
    );
}

export function BodyTextHome(props) {
    return (
        <>
            <Typography
                style={{
                    fontSize: '20px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#828282'
                }}>
                {props.text}
            </Typography>
        </>
    );
}

export function ButtonText(props) {
    return (
        <Typography
            style={{
                fontSize: '15px',
                // fontFamily: 'Roboto',
                color: props.color ? props.color : '#ffffff',
            }}>
            {props.text}
        </Typography>
    );
}

export function BodyTextHeading(props) {
    return (
        <>
            <Typography
                style={{
                    fontSize: '20px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#333333',
                    fontWeight: 'bolder',
                    // marginLeft: '20px',
                    // marginTop: '15px',
                    // textAlign: 'left',
                    // fontFamily: 'Roboto',
                    // color: '#828282',
                    // fontSize: '25px',
                    // letterSpacing: '-0.0016em',
                    // fontStyle: 'normal',
                    // lineHeight: 'normal',
                }}>
                {props.text}
            </Typography>
        </>
    );
}

export function BodyTextKey(props) {
    return (
        <>
            <Text
                style={{
                    fontSize: '15px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#333333',
                    fontWeight: 'bolder'
                }}>
                {props.text}
            </Text>
        </>
    );
}

export function BodyTextValue(props) {
    return (
        <>
            <Text
                style={{
                    fontSize: '15px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#333333'
                }}>
                {props.text}
            </Text>
        </>
    );
}

export function TittleHeader(props) {
    return (
        <Typography
            style={{
                // fontFamily: 'Roboto',
                color: props.color ? props.color : '#ffffff',
                // marginLeft: '1%',
                textAlign: 'left',
                // fontFamily: 'Roboto',
                fontSize: '27px',
                padding: '8px',
            }}>
            {props.text}
        </Typography>
    );
}

export function AppointmentTileHeader(props) {
    return (
        <Typography
            style={{
                // fontFamily: 'Roboto',
                color: props.color ? props.color : null,
                // marginLeft: '1%',
                textAlign: 'left',
                // fontFamily: 'Roboto',
                fontSize: '18px',
                padding: '8px',
            }}>
            {props.text}
        </Typography>
    );
}

export function BodyTextGrey(props) {
    return (
        <>
            <Text
                style={{
                    fontSize: '14px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#828282',
                    lineHeight: 'normal',
                    letterSpacing: '-0.0016em',
                    fontStyle: 'normal',
                    // fontWeight : 'bolder'
                }}>
                {props.text}
            </Text>
        </>
    );
}

export function BodyTextHeadingAppointment(props) {
    return (
        <>
            <Typography
                style={{
                    fontSize: '15px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#333333',
                    fontWeight: 'bolder',
                }}>
                {props.text}
            </Typography>
        </>
    );
}

export function BodyTextHeadingSmall(props) {
    return (
        <>
            <Typography
                style={{
                    fontSize: '20px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#333333',
                    // fontWeight: 'bolder',
                    // marginLeft: '20px',
                    // marginTop: '15px',
                    // textAlign: 'left',
                    // fontFamily: 'Roboto',
                    // color: '#828282',
                    // fontSize: '25px',
                    // letterSpacing: '-0.0016em',
                    // fontStyle: 'normal',
                    // lineHeight: 'normal',
                }}>
                {props.text}
            </Typography>
        </>
    );
}

export function ModalTittle(props) {
    return (
        <>
            <Typography
                style={{
                    fontSize: '25px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#333333',
                    // fontWeight: 'bolder',
                }}>
                {props.text}
            </Typography>
        </>
    );
}

export function ModalHeading(props) {
    return (
        <>
            <Typography
                style={{
                    fontSize: '20px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#333333',
                    // fontWeight: 'bolder',
                }}>
                {props.text}
            </Typography>
        </>
    );
}

export function ModalData(props) {
    return (
        <>
            <Text
                style={{
                    fontSize: '15px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#828282',
                    // fontWeight: 'bolder',
                }}>
                {props.text}
            </Text>
        </>
    );
}

export function CardHeading(props) {
    return (
        <>
            <Typography
                style={{
                    fontSize: '16px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#4F4F4F',
                    // fontWeight: 'bolder',
                }}>
                {props.text}
            </Typography>
        </>
    );
}

export function TableHeading(props) {
    return (
        <>
            <Typography
                style={{
                    fontSize: '15px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#333333',
                    // fontWeight: 'bolder',
                }}>
                {props.text}
            </Typography>
        </>
    );
}

export function ListingHeader(props) {
    return (
        <Text
            style={{
                // fontFamily: 'Roboto',
                color: props.color ? props.color : null,
                // marginLeft: '1%',
                textAlign: 'left',
                // fontFamily: 'Roboto',
                fontSize: '18px',
            }}>
            {props.text}
        </Text>
    );
}

export function BodyTextHeadingListing(props) {
    return (
        <>
            <Typography
                style={{
                    fontSize: '15px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#333333',
                    fontWeight: 'bolder',
                }}>
                {props.text}
            </Typography>
        </>
    );
}

export function BodyTextNewLine(props) {
    return (
        <>
            <Typography
                style={{
                    fontSize: '15px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#333333',
                    marginTop : '5px'
                }}>
                {props.text}
            </Typography>
        </>
    );
}

export function TextDays(props) {
    return (
        <>
            <Text
                style={{
                    fontSize: '20px',
                    // fontFamily: 'Roboto',
                    color: props.color ? props.color : '#333333',
                    fontWeight: 'bolder',
                }}>
                {props.text}
            </Text>
        </>
    );
}